const part = [
    // {
    //     path: 'patent-fee-list',
    //     name: 'patent-fee-list',
    //     meta: {
    //         icon: 'md-stats',
    //         title: '专利费',
    //         notCache: true,
    //         access: ['S', 'A', 'B', 'C', 'I', 'I2'],
    //         items: [
    //         ]
    //     },
    //     component: () => import('@/view/finance-management/patent-fee/patent-fee-list')
    // }
];

export default part;
